<div 
  *ngIf="!(pdfPageVisibleSubject | async)"
  class="page-container"
  
  [ngStyle]="{
    height:(heightObs | async) + 'px',
    width:(widthObs| async) + 'px',
    'margin-bottom':PAGE_SPACING +'px'
  }"
></div>
<div
  *ngIf="(pdfPageVisibleSubject | async)"
  class="position-relative margin-auto"
  [ngStyle]="{
    height:(heightObs | async) + 'px',
    width:(widthObs| async) + 'px',
    'margin-bottom':PAGE_SPACING +'px'
  }"
>
  <img  [src]="imgPathObs | async" 
        class="padding-small-standard border-gray border-radius-smaller background-white"
        [ngStyle]="styleObs | async"
        [height]="heightObs | async"
        [width]="widthObs | async"
  >
  
  <div
    #divOverlay
    class="position-top-left full-stretch page-overlay"
    [ngStyle]="{opacity:(showLoadingObs | async) ? '0.5' : '0'}"
  >
    <mat-spinner
      *ngIf="showLoadingObs | async"
      diameter="60"
      class="page-spinner"
    ></mat-spinner>
  </div>
</div>
